export default __webpack_public_path__ + "static/media/u_r.c82795da.wav";